import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer";
import AboutUs from "./Components/AboutUs";
import ChimneyRepairService from "./Components/Services/ChimneyRepairService";
import HobRepairService from "./Components/Services/HobRepairService";
import CooktopRepairService from "./Components/Services/CookTopRepairService";
import ElectricCooktopRepairService from "./Components/Services/GasStoveRepairService";
import OvenMicrowaveRepairService from "./Components/Services/OvenMicroWareRepairService";
import ContactUs from "./Components/ContactUs";
import CookingRangeService from "./Components/Services/CookingRangeService";
import GasStoveRepairService from "./Components/Services/GasStoveRepairService";
import GasServiceRepair from "./Components/Services/GasServiceRepair";
import SupportWidget from "./Components/SupportWidget";
import AllServices from "./Components/AllServices";
import Gallery from './Components/Gallery';

const App = () => {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/chimney-repair-service" element={<ChimneyRepairService />} />
        <Route path="/hob-repair-service" element={<HobRepairService />} />
        <Route path="/cook-repair-service" element={<CooktopRepairService />} />
        <Route path="/gas-stove-repair-service" element={<GasStoveRepairService />} />
        <Route path="/gas-service-repair-service" element={<GasServiceRepair />} />
        <Route path="/ovenmicroware-repair-service" element={<OvenMicrowaveRepairService />} />
         <Route path="/cooking-range-service" element={<CookingRangeService />} />
         <Route path="/contact-us" element={<ContactUs />} />
         <Route path="/all-services" element={<AllServices />} />
          <Route path="/gallery" element={<Gallery />} />
      </Routes>
      <SupportWidget />
      <Footer />
    </>
  );
};

export default App;
